/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Session } from '../../models/session';

export interface CreateSessionFromReplay$Params {
  session_id: string;
  last_message_index: number;
}

export function createSessionFromReplay(http: HttpClient, rootUrl: string, params: CreateSessionFromReplay$Params, context?: HttpContext): Observable<StrictHttpResponse<Session>> {
  const rb = new RequestBuilder(rootUrl, createSessionFromReplay.PATH, 'post');
  if (params) {
    rb.query('session_id', params.session_id, {});
    rb.query('last_message_index', params.last_message_index, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Session>;
    })
  );
}

createSessionFromReplay.PATH = '/sessions/replay';
